'use strict';

export default class{
	/*@ngInject*/
	constructor($http, $scope, studentID){
		this.$http = $http;
		this.$scope = $scope;
		this.loaded = false;
		this.locations = [{
				fullname: 'Cannon Hill',
				value: 'C'
			},{
				fullname: 'Home',
				value: 'H',
			}, {
				fullname: 'Online',
				value: 'O',
			}, {
				fullname: 'Paddington',
				value: 'P',
			},{
				fullname: 'Mt Gravatt',
				value: 'M',
			}];
		this.studentID = studentID;
		this.states = ['QLD', 'NSW', 'VIC', 'SA', 'WA', 'TAS', 'NT', 'ACT'];
	}

	$onInit(){
		this.$http.get('/api/students/' + this.studentID).then(res => {
			this.student = res.data;

			console.log(this.student);
			this.loaded = true;
		})
	}

	edit(callback){
		var regex = /\d+-[1-9]/;
		if (regex.test(this.student.crmID) && this.student.crmID.split('-')[0].length === 5) {
			this.$http.get('/api/students/crm-id', {params: {id: this.student.crmID}}).then(res => {
				if (res.data === "" || res.data._id === this.student._id){
					this.$scope.error = null;
					this.$http.put('/api/students/' + this.student._id, this.student).then(res => {
						callback();
					})
				} else{
					this.$scope.error = "The CRM ID already exists. Try another one";
				}
			})
		} else {
			this.$scope.error = "Wrong format CRM ID";
		}
	}
}


// WEBPACK FOOTER //
// ./client/app/modals/edit-student/edit-student.controller.js